import { selectedCalendarsStore } from '../store/store';
import { mutator } from 'satcheljs';
import { userConfigurationSet } from 'owa-session-store';
import { getUserMailboxInfo } from 'owa-client-ids';

mutator(userConfigurationSet, actionMessage => {
    const { userConfiguration, primarySmtpAddress } = actionMessage;

    selectedCalendarsStore().selectedCalendars.set(
        primarySmtpAddress ? primarySmtpAddress : getUserMailboxInfo().primarySmtpAddress,
        userConfiguration.ViewStateConfiguration.SelectedCalendarsDesktop
    );
});
